import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ITStaffingContracts from './pages/ITStaffingContracts';
import ITServices from './pages/ITServices';
import WorkForceSolutions from './pages/WorkForce';
import Career from './pages/Career';
import Contact from './pages/Contact';
import EmploiProduct from './pages/EmploiProduct';
import PayloiProduct from './pages/PayloiProduct';
import KrishparHiring from './pages/KrishparHiring';
import KrishparPayroll from './pages/KrishparPayroll';
import KrishparStaffing from './pages/KrishparStaffing';
import KrishparStaffAugmentation from './pages/KrishparStaffAugmentation';
import PayrollProduct from './pages/PayrollProduct';
import HRCompliance from './pages/HRCompliance';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import './index.css';

// ScrollToTop component
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Multiple scroll-to-top methods for cross-browser compatibility
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Also try after a short delay to ensure it works
    const scrollTimer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
    
    return () => clearTimeout(scrollTimer);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/it-staffing-contracts" element={<ITStaffingContracts />} />
            <Route path="/it-services" element={<ITServices />} />
            <Route path="/workforce" element={<WorkForceSolutions />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/emploi-product" element={<EmploiProduct />} />
            <Route path="/payloi-product" element={<PayloiProduct />} />
            <Route path="/payroll-product" element={<PayrollProduct />} />
            <Route path="/krishpar-hiring" element={<KrishparHiring />} />
            <Route path="/payroll-services" element={<KrishparPayroll />} />
            <Route path="/general-staffing" element={<KrishparStaffing />} />
            <Route path="/staff-augmentation" element={<KrishparStaffAugmentation />} />
            <Route path="/hr-compliance-advisory" element={<HRCompliance />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
